import { resolveMatchMapIdFromSelectionKey } from "../../constants/maps";

const CUSTOM_MAP_SUBSCRIPTION_CONFIRMATIONS_KEY =
    "ouro.customMapSubscriptionConfirmations.v1";

export function extractMatchIdFromRoutePath(path) {
    const normalizedPath = String(path || "").trim();
    if (!normalizedPath) return null;
    const match = normalizedPath.match(/^\/match\/([^/?#]+)/i);
    if (!match?.[1]) return null;
    return decodeURIComponent(match[1]);
}

export function getMatchServerReadyMatchId(message = {}) {
    if (message?.matchId != null && String(message.matchId).trim() !== "") {
        return String(message.matchId).trim();
    }
    return extractMatchIdFromRoutePath(message?.redirectTo);
}

export function isAlreadyOnMatchRoute(path, matchId) {
    if (matchId == null || String(matchId).trim() === "") {
        return false;
    }
    const currentMatchId = extractMatchIdFromRoutePath(path);
    if (!currentMatchId) return false;
    return currentMatchId === String(matchId).trim();
}

export function normalizeMapSelectionToMapId(mapName) {
    return resolveMatchMapIdFromSelectionKey(mapName);
}

export function normalizeLocationId(locationId) {
    if (locationId === null || locationId === undefined) {
        return "";
    }
    return String(locationId).trim();
}

export function buildWorkshopItemUrl(workshopItemId) {
    const normalized = String(workshopItemId || "").trim();
    if (!normalized) return null;
    return `https://steamcommunity.com/sharedfiles/filedetails/?id=${encodeURIComponent(
        normalized,
    )}`;
}

export function maskInviteCode(code) {
    if (!code || code.length < 5) return code;
    const firstThree = code.substring(0, 3);
    const lastTwo = code.substring(code.length - 2);
    const middleLength = code.length - 5;
    return `${firstThree}${"•".repeat(middleLength)}${lastTwo}`;
}

export function summarizeRecapItems(items, maxItemsOrOptions = 2) {
    const opts =
        typeof maxItemsOrOptions === "number"
            ? { maxItems: maxItemsOrOptions }
            : { maxItems: 2, ...(maxItemsOrOptions || {}) };

    const {
        maxItems = 2,
        total = null,
        allLabel = null,
        emptyLabel = "None",
    } = opts;

    const safeItems = [...new Set((items || []).filter(Boolean))];
    if (safeItems.length === 0) {
        return { text: emptyLabel, isEmpty: true };
    }
    if (
        allLabel &&
        typeof total === "number" &&
        total > 0 &&
        safeItems.length >= total
    ) {
        return { text: allLabel, isEmpty: false };
    }
    if (safeItems.length <= maxItems) {
        return { text: safeItems.join(", "), isEmpty: false };
    }
    const visible = safeItems.slice(0, maxItems).join(", ");
    return {
        text: `${visible} +${safeItems.length - maxItems}`,
        isEmpty: false,
    };
}

export function readConfirmedCustomMapWorkshopIds() {
    if (typeof window === "undefined" || !window.localStorage) {
        return new Set();
    }
    try {
        const raw = window.localStorage.getItem(
            CUSTOM_MAP_SUBSCRIPTION_CONFIRMATIONS_KEY,
        );
        if (!raw) return new Set();
        const parsed = JSON.parse(raw);
        if (!Array.isArray(parsed)) return new Set();
        return new Set(
            parsed
                .map((value) => String(value || "").trim())
                .filter(Boolean),
        );
    } catch (_err) {
        return new Set();
    }
}

export function writeConfirmedCustomMapWorkshopIds(workshopIds) {
    if (typeof window === "undefined" || !window.localStorage) {
        return;
    }
    try {
        const deduped = [...new Set((workshopIds || []).filter(Boolean))]
            .map((value) => String(value || "").trim())
            .filter(Boolean)
            .sort();
        window.localStorage.setItem(
            CUSTOM_MAP_SUBSCRIPTION_CONFIRMATIONS_KEY,
            JSON.stringify(deduped),
        );
    } catch (_err) {
        // localStorage might be blocked by browser/privacy settings.
    }
}
